export default {
  ENTERPRISE: {
    INDEX: {
      PATH: '/b/:businessSlug/enterprise',
      NAME: 'enterprise.index',
    },
    SUBJECTS: {
      INDEX: {
        PATH: '/b/:businessSlug/enterprise/subject-businesses',
        NAME: 'enterprise.subject-businesses',
      },
    },
    ROLES: {
      INDEX: {
        PATH: '/b/:businessSlug/enterprise/roles',
        NAME: 'enterprise.roles',
      },
    },
    USERS: {
      INDEX: {
        PATH: '/b/:businessSlug/enterprise/users',
        NAME: 'enterprise.users',
      },
    },
  },
}
